import { z } from 'zod';

export const CompetitionFinderDetails = z.object({
  businessType: z.string().nonempty(),
  address: z.string().nonempty(),
  latitude: z.number().refine((lat) => lat <= 90 && lat >= -90, {
    message: 'Invalid latitude value. Must be between -90 and 90',
  }),
  longitude: z.number().refine((long) => long <= 180 && long >= -180, {
    message: 'Invalid longitude value. Must be between -180 and 180',
  }),
});

export type CompetitionFinderDetails = z.infer<typeof CompetitionFinderDetails>;
